export default __webpack_public_path__ + "static/media/telephony-demo.1d54a718.mp3";